import i18n from '../../lang/index'
const whiteRouter = [{
  path: '/workorder',
  component: () => import('@/pages/Index'),
  redirect: {
    name: 'workOrderList'
  },
  children: [{
      name: 'workOrderList',
      path: 'list',
      component: () => import('@/pages/workOrder/orderList'),
      meta: {
        tab: '',
        title: '工单列表',
      },
    },
    {
      name: 'create',
      path: 'create',
      component: () => import('@/pages/workOrder/createOrder'),
      meta: {
        tab: '',
      },
    },
    {
      name: 'detail',
      path: 'detail',
      component: () => import('@/pages/workOrder/OrderDetail'),
      meta: {
        tab: '',
      },
    },
  
  ]
}]
export default whiteRouter



// WEBPACK FOOTER //
// ./src/router/modules/workOrder.js